/*/
// ## EF.Models.ActivityProgress
//
// Retrieves an ActivityProgress object, which is created when an
// enrollment completes a module, survey, or assessment.
//
// Example response:
//
// {
//   "id": 24201382,
//   "activity_id": 31,
//   "passed": true,
//   "created_at": "2014-04-17T08:41:43Z",
//   "updated_at": "2014-04-17T08:41:43Z",
//   "grade": 80,
//   "enrollment_id": 2269168,
//   "deleted_at": null,
//   "attempt": 1,
//   "status": null
// }
/*/
(function(EF) {

  var ActivityProgress = Backbone.Model.extend({
    sync: function(method, model, options) {
      if(method === 'read') {
        return Backbone.sync(method, model, options);
      } else {
        throw new Error('Model is read only');
      }
    },

    urlRoot: function() {
      var id = this.get('enrollment_id') || this.enrollment.get('id');
      return EF.url('/sdk/enrollments/' + id + '/activity_progresses.json');
    }
  });

  _.extend(EF.Models, {
    ActivityProgress: ActivityProgress
  });

}(EF));
